import { render, staticRenderFns } from "./RegisXAddSubject.vue?vue&type=template&id=79fdeb54&scoped=true"
import script from "./RegisXAddSubject.vue?vue&type=script&lang=js"
export * from "./RegisXAddSubject.vue?vue&type=script&lang=js"
import style0 from "./RegisXAddSubject.vue?vue&type=style&index=0&id=79fdeb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fdeb54",
  null
  
)

export default component.exports